<template>
  <div class="drawer-container">
    <div :class="isOpen ? 'sidenav is-open' : 'sidenav is-not-open'">
      <span class="closebtn" @click="closeNav()">&times;</span>
      <router-link to="/">Home</router-link>
      <a href="#todaysection">Today</a>
      <a href="#sectionnextweek">Next week</a>
      <a href="#sectionmonthly">Monthly</a>
      <router-link to="/january">January</router-link>
      <router-link to="/february">February</router-link>
      <router-link to="/march">March</router-link>
      <router-link to="/april">April</router-link>
      <router-link to="/may">May</router-link>
      <router-link to="/june">June</router-link>
      <router-link to="/july">July</router-link>
      <router-link to="/sugust">August</router-link>
      <router-link to="/september">September</router-link>
      <router-link to="/october">October</router-link>
      <router-link to="/november">November</router-link>
      <router-link to="/december">December</router-link>
      <router-link to="/alif">Alif</router-link>
      <router-link to="/alif2">Alif 2</router-link>
      <router-link to="/alif-kasra">Alif Kasra</router-link>
    </div>
    <div @click="openNav" :class="isOpen ? 'hide-button' : 'btn-open-drawer'">
      <div class="h-menu"></div>
      <div class="h-menu"></div>
      <div class="h-menu"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Drawer",
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    /* Set the width of the side navigation to 250px */
    openNav() {
      this.isOpen = true;
    },

    /* Set the width of the side navigation to 0 */
    closeNav() {
      this.isOpen = false;
    },
  },
};
</script>
<style>
.drawer-container {
  position: relative;
  top: 0;
  left: 0;
}
.is-open {
  width: 250px;
}
.is-not-open {
  width: 0;
}
.btn-open-drawer {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1;
  display: block;
  transition: all 2s ease-out;
}

.btn-open-drawer:hover .h-menu {
  margin: 7px 0;
}

.hide-button {
  z-index: -1;
  display: none;
  transition: all 2s ease-out;
}

.h-menu {
  width: 35px;
  height: 5px;
  background-color: white;
  margin: 6px 0;
  transition: all 0.2s ease-out;
  cursor: pointer;
}
</style>
